<template lang="pug">
  div.channel-type
    nav.types
      label.type(v-for="nav in types" :class="{active: type === nav.key}" :key="nav.key" @click.prevent="selectType(nav)") {{nav.name}}
    div.list(v-for="l in lists" :class="{active: channelType === l.type}" @click.prevent="getType(l)")
      div.info
        div.logo
          img(:src="l.imgUrl")
          p {{l.name}}
        div.name {{l.type}}
      div.details
        div.channel
          span.color {{l.channelCount}}家
          p 参与渠道
        div.report
          span.color {{l.articleCount}}篇
          p 发布报道
</template>

<script>
import client from '../server/server'
import bus from './bus'

export default {
  name: 'ChannelType',
  props: {
    getChannel: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      type: '媒体',
      types: [
        {
          key: '媒体',
          name: '媒体'
        },
        {
          key: '重要KOL',
          name: '重要KOL'
        }
      ],
      channelType: '',
      lists: []
    }
  },
  mounted () {
    this.getTypeList()
  },
  methods: {
    getTypeList () {
      let params = {
        id: this.$route.params.id,
        type: this.type
      }
      client.getEventChannelType(params)
        .then(res => {
          if (res.success) {
            this.lists = res.data.map(d => {
              return Object.assign({}, d, {
                imgUrl: require(`@index/assets/img/event/${d.name}.png`)
              })
            })
            this.getType(this.lists[0])
          }
        })
    },
    selectType (nav) {
      if (this.type !== nav.key) {
        this.type = nav.key
        this.getTypeList()
      }
    },
    getType (l) {
      if (l) {
        this.channelType = l.type
        this.getChannel(l.type)
        console.log(this.channelType)
        // 通过Bus发送出去
        bus.$emit('mediaTypeSend', this.channelType)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .channel-type{
    height: 100%;
    flex: 1;
    margin-right: 20px;
    nav.types{
      padding: 14px;
      display: flex;
      align-items: center;
      font-size: 12px;
      label.type{
        padding: 4px 13px;
        background-color: #fff;
        color: #333;
        border-radius: 13px;
        cursor: pointer;
        &.active{
          color: #3989cb;
          background-color: #ebf3fa;
        }
      }
    }
    .list{
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      cursor: pointer;
      &.active{
        background-color: #fafafa;
      }
      .info{
        display: flex;
        align-items: center;
        .logo{
          width: 70px;
          height: 70px;
          background-color: #ffffff;
          border-radius: 4px;
          border: solid 1px #3989cb;
          text-align: center;
          img{
            margin: 10px 0 5px;
          }
          p{
            font-size: 16px;
            color: #3989cb;
          }
        }
        .name{
          margin-left: 30px;
        }
      }
      .details{
        display: flex;
        align-items: center;
        .color{
          font-size: 12px;
          color: #f87653;
          margin-bottom: 6px;
        }
        p{
          font-size: 12px;
          color: #666;
        }
        .channel{
          text-align: center;
        }
        .report{
          margin: 0 24px 0 60px;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventChannel/ChannelType.vue